import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { Outlet } from 'react-router-dom'
import { can, permissionForPath } from '../../configTools/permissions'

// Guards the 13 print/report pages. These are a separate top-level route group, not children of
// /labadmin, and none of them has a sidebar entry - they open in new windows from buttons. So
// menu filtering could never protect them, and this check is the only client-side cover for the
// financial ones (billing statements, sales, profit & loss).
const Index = () => {
    const User = JSON.parse(localStorage.getItem("user-info"));
    const location = useLocation();
    if(!User){
        return <Navigate to={"/login"}/>
    }
    if(User.role !== 'labadmin' && User.role !== 'employee'){
        return <Navigate to={"/login"}/>
    }
    const required = permissionForPath(location.pathname);
    if(!can(User,required)){
        // These open in their own window and print themselves, so bouncing to another page would
        // be confusing - say plainly what happened instead. The API blocks the data regardless.
        return (
            <div style={{padding:'40px', textAlign:'center', fontSize:'14px', color:'#4a4a4a'}}>
                <p>You do not have access to this report.</p>
                <p style={{fontSize:'12px', color:'#8a8a8a', paddingTop:'8px'}}>
                    Ask your lab administrator if you need it.
                </p>
            </div>
        );
    }
  return (
    <Outlet />
  )
}

export default Index
